"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _ThemeProviderContext = _interopRequireDefault(require("./_ThemeProviderContext"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
    theme = _ref.theme,
    setTheme = _ref.setTheme;
  var contextValue = (0, _react.useMemo)(function () {
    return {
      theme: theme,
      setTheme: setTheme
    };
  }, [theme]);
  return /*#__PURE__*/_react.default.createElement(_ThemeProviderContext.default.Provider, {
    value: contextValue
  }, children);
};
ThemeProvider.propTypes = {
  children: _propTypes.default.any,
  theme: _propTypes.default.string,
  setTheme: _propTypes.default.func
};
ThemeProvider.defaultProps = {
  theme: 'concur_gateway',
  setTheme: function setTheme() {}
};
var _default = exports.default = ThemeProvider;